<template>
  <div class="min-height bg-f2 pad10-t pad10-lr">
    <el-row :gutter="20">
      <el-col :span="18">
        <div class="radius20 pad20 h180 bg-white overflow">
          <h2 class="flex justify-between">
            <div class="f18 fb gray3">
              标书交易数据
              <el-button class="btn-plus" @click="handleRefresh" type="text" icon="el-icon-refresh">刷新</el-button>
            </div>
            <div class="flex items-center">
              <img v-if="collectInfo.publishBidUrl" src="./images/icon-plus.png" style="width: 18px; height: 18px" class="mar5_r" />
              <el-button class="btn-plus" v-if="collectInfo.publishBidUrl" type="text" @click="openUrl(collectInfo)"> 创建标书</el-button>
            </div>
          </h2>
          <div class="flex justify-between">
            <div
              v-for="(item, index) in collectInfo.bidDataList"
              :key="index"
              @click="handelUrl(item)"
              class="flex justify-between items-center pad20 card1 mar10_r"
              :class="[item.havePermission != 1 ? 'opacity3' : '']"
            >
              <div>
                <div class="f30 gray3">{{ item.amount }}</div>
                <div class="f14 gray6">{{ item.typeCn }}</div>
              </div>
              <el-image style="width: 52px; height: 52px" :src="item.icon" fit="fill"></el-image>
            </div>
          </div>
        </div>
        <div class="flex justify-between">
          <div class="h160 relative w49">
            <div class="radius20 pad20 bg-white mar18_t overflow popover" :class="[isMouseMenu ? 'show_card' : '']">
              <h2 class="f18 fb gray3 mar20-b">交易管理</h2>
              <div class="flex justify-between">
                <div class="flex justify-between w100 popover_div" @mouseover="isMouseMenu = true" @mouseleave="isMouseMenu = false">
                  <div
                    v-for="(item, index) in isMouseMenu ? userMenuList : userMenuList.slice(0, 2)"
                    :key="index"
                    class="flex card3 mar10_r"
                    :class="[item.havePermission != 1 ? 'opacity3' : '']"
                    @click="handelUrl(item)"
                  >
                    <el-image style="width: 52px; height: 52px" :src="item.icon" fit="fill"></el-image>
                    <div class="mar20-l info">
                      <div class="f20 fb gray3">{{ item.menuName }}</div>
                      <div class="f14 gray3 sub_title ellipsis2">{{ item.subTitle }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="h160 relative w49">
            <div class="radius20 pad20 bg-white mar18_t overflow popover" :class="[isMouseBid ? 'show_card' : '']">
              <h2 class="f18 fb gray3 mar20-b">报表管理</h2>
              <div class="flex justify-between">
                <div class="flex justify-between w100 popover_div" @mouseover="isMouseBid = true" @mouseleave="isMouseBid = false">
                  <div
                    v-for="(item, index) in isMouseBid ? bidList : bidList.slice(0, 2)"
                    :key="index"
                    class="flex card3 mar10_r"
                    :class="[item.havePermission != 1 ? 'opacity3' : '']"
                    @click="handelUrl(item)"
                  >
                    <el-image style="width: 52px; height: 52px" :src="item.icon" fit="fill"></el-image>
                    <div class="mar20-l info">
                      <div class="f20 fb gray3">{{ item.menuName }}</div>
                      <div class="f14 gray3 sub_title ellipsis2">{{ item.subTitle }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="flex flex-column justify-center items-center radius20 bg-white code">
          <el-image style="width: 170px; height: 170px" :src="miniQrCodeUrl" fit="fill"></el-image>
          <span class="f14 color-7f mar30-t">扫码打开/分享小程序</span>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="20" class="pad10-lr">
      <div class="radius20 pad20 bg-white mar20_t" v-for="(pre, index) in tList" :key="index">
        <h2 class="f18 fb gray3 mar20-b">{{ pre.tags }}</h2>
        <div class="flex flex-wrap">
          <div
            class="flex card2 pad20_tb mar10_r mar30-b"
            v-for="(item, index) in pre.child"
            :key="index"
            :class="[item.havePermission != 1 ? 'opacity3' : '']"
            @click="handelUrl(item)"
          >
            <el-image style="width: 52px; height: 52px" :src="item.icon" fit="fill"></el-image>
            <div class="mar20-l info">
              <div class="f20 fb gray3">{{ item.menuName }}</div>
              <div class="f14 gray3 sub_title ellipsis2">{{ item.subTitle }}</div>
            </div>
          </div>
        </div>
      </div>
    </el-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isMouseMenu: false,
      isMouseBid: false,
      collectInfo: {},
      miniQrCodeUrl: "",
      userMenuList: [],
      bidList: [],
      tList: [],
      loading: undefined,
    };
  },
  created() {
    const { type = "" } = this.$route.params;
    const { platform_type } = this.$route.query;
    this.platform_type = platform_type;
    if (type === "jj") {
      document.title = "竞价业务";
      this.application_type = "JJ";
    } else {
      document.title = "招标业务";
      this.application_type = "ZB";
    }
    this.getCollect();
    this.getDomainConfig();
    this.getData();
    this.getMenuList();
    this.getBidData();
  },
  methods: {
    handleRefresh() {
      this.loading = this.$loading({
        lock: false,
        text: "加载中...",
        background: "rgba(0, 0, 0, 0.7)",
        customClass: "seller-style",
      });
      this.getCollect();
    },
    async getCollect() {
      let params = {
        open_req_src: "nxmall_agr",
        platform_type: this.platform_type,
        application_type: this.application_type,
      };

      let res = await this.$store.dispatch("auctionSales/auctionSales/collect", params);
      this.loading && this.loading.close();
      if (res.code == 0) {
        this.collectInfo = res.data;
      }
    },
    openUrl(item) {
      if (item.havePermission) {
        window.parent.postMessage({ fn: "open", data: { url: item.publishBidUrl, title: item.menuName, target: 0 } }, "*");
      } else {
        this.$message.warning("暂无权限");
      }
    },
    handelUrl(item, falg) {
      console.log(falg);
      console.log(item);
      if (falg) {
        window.parent.postMessage({ fn: "open", data: { url: item.url, title: item.menuName || item.typeCn, target: 0 } }, "*");
        return;
      }
      if (item.havePermission) {
        window.parent.postMessage({ fn: "open", data: { url: item.url, title: item.menuName || item.typeCn, target: 0 } }, "*");
      } else {
        this.$message.warning("暂无权限");
      }
    },
    getDomainConfig() {
      const params = {
        platform_type: this.platform_type,
        application_type: this.application_type,
      };
      this.$store.dispatch("business/domainConfig", params).then((res) => {
        console.log("res", res);
        if (res) {
          this.miniQrCodeUrl = res.miniQrCodeUrl || "";
        }
      });
    },
    getMenuList() {
      const params = {
        platform_type: this.platform_type,
        application_type: this.application_type,
      };
      this.$store.dispatch("business/getMenuList", params).then((res) => {
        console.log("res", res);
        if (res && res.length) {
          this.tList = res;
        }
      });
    },
    getData() {
      const params = {
        platform_type: this.platform_type,
        application_type: this.application_type,
      };
      this.$store.dispatch("business/userMenuList", params).then((res) => {
        if (res && res.length) {
          this.userMenuList = res;
        }
      });
    },
    getBidData() {
      const params = {
        platform_type: this.platform_type,
        application_type: this.application_type,
        bid_home_menu_code: "BID_HOME_MENU_SHOW_CODE_REPORT",
      };
      this.$store.dispatch("business/getMenuList", params).then((res) => {
        if (res && res.length) {
          this.bidList = res[0].child;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.btn-plus {
  color: #409eff;
}
.w49 {
  width: 49%;
}

.popover {
  width: 100%;
  position: absolute;
  z-index: 99;
  height: 100%;
}
.show_card {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  height: auto;
}
.popover_div {
  width: 100%;
  flex-wrap: wrap;
}
.card1 {
  width: 220px;
  height: 90px;
  background: #f5f9ff;
  border-radius: 8px;
  cursor: pointer;
}
.card3 {
  width: 48%;
  height: 90px;
  cursor: pointer;
}

.card2 {
  width: 300px;
  height: 96px;
  cursor: pointer;

  > .info {
    width: 180px;
  }
}
.code {
  height: 360px;
}

.opacity3 {
  opacity: 0.3;
  cursor: not-allowed;
}
</style>
